// third-party
import { configureStore } from "@reduxjs/toolkit"

// project import
import reducers from "./reducers"
import apiService from "services/apiService"

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const store = configureStore({
  reducer: {
    [apiService.reducerPath]: apiService.reducer,
    ...reducers,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiService.middleware),
})

const { dispatch } = store

export { store, dispatch }
